'use client';

import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { ArrowLeftS } from '@lichtblick/photon/icons/arrows/arrow-left-s';
import { useRouter } from 'next/navigation';

import styles from './header.module.scss';

export const BackButton: React.FC = () => {
  const router = useRouter();

  return (
    <TextCTA
      ariaLabel="Zurück"
      as="button"
      className={styles['back-button']}
      data-testid="button-back"
      icon={<ArrowLeftS />}
      onClick={() => router.back()}
    />
  );
};
